import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { routes } from '../../constants';
import Button from '../../components/Button';
import * as T from '../../components/Typography';
import colors from '../../theme/colors';
import logoWhiteBg from '../../components/assets/logo-navy.png';


const ChangePasswordSuccess: React.FC = () => {

  const navigate = useNavigate();

  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid
        container
        maxWidth={'384px'}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Box mb={5}>
          <img src={logoWhiteBg} alt="account verified" width="118" height="48" />
        </Box>
        <Box mb={1}>
          <T.H4
            ta="center"
            color={colors.neutral.shades.shade700}
          >
            YOUR PASSWORD HAS BEEN SUCCESSFULLY RESET
          </T.H4>
        </Box>
        <Box mb={5}>
          <T.TextSmallRegular
            ta="center"
            center
            color={colors.neutral.shades.shade600}
          >
            You can now log in with your new password.
          </T.TextSmallRegular>
        </Box>
      </Grid>
      <Grid item maxWidth={'384px'}>
        <Button
          type="submit"
          variant="blue"
          handleClick={() => navigate(routes.LOGIN)}
        >
          Log in
        </Button>
      </Grid>

      <Box mt={5}>
        <T.Link
          to={routes.LOGIN}
          size="16px"
          weight="400"
          style={{
            color: colors.blue.shades.shade700,
          }}
        >
          Back to home page
        </T.Link>
      </Box>
    </Grid>
  );
};

export default ChangePasswordSuccess;
